<template>
  <div class="d-flex flex-row mt-2" style="gap: 32px">
    <div v-for="(line, index) in lineItems" :key="index" class="d-flex flex-column">
      <span class="product-label">{{ line.label }}</span>
      <span class="product-value">{{ formatValue(line.value, line.format) }}</span>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import { localeString } from '@/config/helpers.js'

const lineValidator = (line) =>
  Boolean(line.label && line.label instanceof String && line.value && line.format && ['text', 'percent', 'currency'].includes(line.format))

export default {
  name: 'OfferSaleLine',
  props: {
    lineItems: {
      type: Array,
      required: true,
      validators: lineValidator,
    },
  },
  methods: {
    formatValue(value, format) {
      if (!value) return '-'
      switch (format) {
        case 'percent':
          return localeString(value || 0) + '%'
        case 'currency':
          return `R$ ${localeString(value || 0, 2)}`
        case 'text':
        default:
          return value
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.product-label {
  font-size: 14px;
  font-weight: 400;
  color: $cinza-l30;
}

.product-value {
  color: $cinza-d10;
  font-weight: 700;
}
</style>
